// -*- mode: vue; js-indent-level: 2; -*-
<template lang="html">
  <b-row no-gutters class="dealer-map-container">
      <b-col cols=12>
          <div class="zoom-controls">
              <button @click="zoomIn" class="zoom-btn zoom-in">+</button>
              <button @click="zoomOut" class="zoom-btn zoom-out">−</button>
          </div>

          <div class="filter-icons">
              <div 
                  v-for="group in availableGroups" 
                  :key="group.id" 
                  class="filter-icon"
                  :class="{ 'filter-icon-active': selectedGroups.includes(group.id) }"
                  @click="toggleGroup(group.id)"
              >
                  <i :class="group.icon"></i>
                  <div class="filter-tooltip">{{ group.label }} ({{ getDealerCountByGroup(group.id) }})</div>
              </div>
          </div>

          <MglMap ref="map" :accessToken="accessToken" :mapStyle="mapStyle" :minZoom="minZoom" :maxZoom="maxZoom" :center="center" :zoom="zoom" :pitch="0">
              <MglMarker :coordinates="brewery.coordinates" :title="brewery.name" :draggable="false">
                  <div slot="marker" class="brewery-marker">
                      <img :src="brewery.logo" alt="Brasserie du Singe Savant" />
                  </div>
                  <MglPopup>
                      <div>
                          <h4>{{ brewery.name }}</h4>
                          {{ brewery.address }}
                          <br/><small><em>Là ou toutes nos bières sont brassées - <router-link :to="{name: 'brewery/visit'}">Visiter la brasserie</router-link></em></small>
                      </div>
                  </MglPopup>
              </MglMarker>

              <MglMarker :coordinates="bar.coordinates" :title="bar.name" :draggable="false">
                  <div slot="marker" class="brewery-marker">
                      <img class="bar-logo" :src="bar.logo" alt="Bar du Singe Savant" />
                  </div>
                  <MglPopup>
                      <div>
                          <h4>{{ bar.name }}</h4>
                          {{ bar.address }}
                          <br/><small><em><router-link :to="{name: 'taproom'}">Venez gouter nos bières</router-link></em></small>
                      </div>
                  </MglPopup>
              </MglMarker>

              <MglMarker v-for="dealer in filteredDealers" :key="dealer.name" :coordinates="dealer.position" :title="dealer.name" :draggable="false">
                  <div slot="marker" class="custom-marker">
                      <i :class="getMarkerIconClass(dealer.spot_type)"></i>
                  </div>
                  <MglPopup>
                      <div>
                          <h4>{{ dealer.name }}</h4>
                          {{ dealer.spot_type }}
                          <br/>
                          {{ filterAddress(dealer.address) }}
                      </div>
                  </MglPopup>
              </MglMarker>

          </MglMap>

      <monkey-footer/>
    </b-col>
  </b-row>

</template>

<script lang="js">
import { mapState } from 'vuex'
import MonkeyFooter from '../Footer'

import Mapbox from "mapbox-gl";
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";


// var ResizedIcon = L.Icon.extend({options: {iconSize: [40, 40], iconAnchor: [20, 20], popupAnchor: [0, -20]}})

var data = {
    zoom: 13.0,
    minZoom: 8.0,
    maxZoom: 15.0,
    center: [3.0612, 50.6330],
    stickerIcon: null, //new ResizedIcon({iconUrl: '/images/marker-icon.png'}),

    accessToken: "pk.eyJ1Ijoic2luZ2VzYXZhbnQiLCJhIjoiY2tsY2RiY2J6MG9nMzJ3czR3ejdwcGZxOCJ9.OfGS7zMY7PuU0kVjJrPm2Q", // your access token. Needed if you using Mapbox maps
    mapStyle: "mapbox://styles/mapbox/dark-v10", // your map style
    selectedGroups: [],
    showFilterPanel: false,
    brewery: {
        name: 'Brasserie du Singe Savant',
        address: '134 rue d\'Arras, 59000 Lille',
        coordinates: [3.066089628835527, 50.62133450601392],
        logo: '/images/home/logo.png'
    },
    bar: {
        name: 'Bar du Singe Savant',
        address: '94 rue d\'Arras, 59000 Lille',
        coordinates: [3.0670073417286314, 50.622237591063715],
        logo: '/images/home/bar_logo.jpg'
    }
}

const DEALER_GROUPS = [
    {
        id: 'bars',
        label: 'Bars et brasseries',
        icon: 'las la-beer',
        matches: ['bar', 'brasserie']
    },
    {
        id: 'shops',
        label: 'Cavistes et Supermarchés',
        icon: 'las la-shopping-bag',
        matches: ['caviste', 'supermarch', 'épicerie', 'epicerie', 'cave', 'magasin', 'store']
    },
    {
        id: 'restaurants',
        label: 'Restaurants',
        icon: 'las la-hamburger',
        matches: ['resto', 'restaurant']
    },
    {
        id: 'others',
        label: 'Autres points de vente',
        icon: 'las la-map-marker',
        matches: []
    }
]

export default {
    name: 'DealerList',

    components: {
        MglMap,
        MglMarker,
        MglPopup,

        'monkey-footer': MonkeyFooter
    },

    computed: {
        ...mapState([
            'dealers'
        ]),
        availableGroups () {
            const groups = new Set()
            this.dealers.forEach(dealer => {
                const groupId = this.getDealerGroupId(dealer.spot_type)
                if (groupId) {
                    groups.add(groupId)
                }
            })
            return DEALER_GROUPS.filter(group => groups.has(group.id))
        },
        filteredDealers () {
            if (!this.dealers || this.dealers.length === 0) {
                return []
            }
            if (this.selectedGroups.length === 0) {
                // Si aucun type sélectionné, ne rien afficher
                return []
            }
            return this.dealers.filter(dealer => {
                return this.selectedGroups.includes(this.getDealerGroupId(dealer.spot_type))
            })
        }
    },

    data: function () {
        return data
    },

    mounted: function () {
        this.$store.dispatch('LOAD_DEALER_LIST')
    },
    watch: {
        dealers: {
            handler () {
                // Initialiser avec tous les groupes sélectionnés si c'est la première fois
                if (this.selectedGroups.length === 0 && this.availableGroups.length > 0) {
                    this.selectedGroups = this.availableGroups.map(group => group.id)
                }
            },
            immediate: true
        }
    },

    created() {
        // We need to set mapbox-gl library here in order to use it in template
        this.mapbox = Mapbox;
    },

    methods: {
        filterAddress (address) {
            if (!address) return ''
            // Enlever les parties "Phone :" et "Email :" et tout ce qui suit
            let filtered = address
            // Enlever "Phone :" et tout ce qui suit
            const phoneIndex = filtered.indexOf('Phone:')
            if (phoneIndex !== -1) {
                filtered = filtered.substring(0, phoneIndex).trim()
            }
            // Enlever "Email :" et tout ce qui suit
            const emailIndex = filtered.indexOf('Email:')
            if (emailIndex !== -1) {
                filtered = filtered.substring(0, emailIndex).trim()
            }
            return filtered
        },
        zoomIn () {
            if (this.zoom < this.maxZoom) {
                this.zoom = Math.min(this.zoom + 1, this.maxZoom)
            }
        },
        zoomOut () {
            if (this.zoom > this.minZoom) {
                this.zoom = Math.max(this.zoom - 1, this.minZoom)
            }
        },
        toggleGroup (groupId) {
            const index = this.selectedGroups.indexOf(groupId)
            if (index > -1) {
                this.selectedGroups.splice(index, 1)
            } else {
                this.selectedGroups.push(groupId)
            }
        },
        getDealerCountByGroup (groupId) {
            if (!this.dealers || this.dealers.length === 0) {
                return 0
            }
            return this.dealers.filter(
                dealer => this.getDealerGroupId(dealer.spot_type) === groupId
            ).length
        },
        getDealerGroupId (spotType) {
            const type = (spotType || '').toLowerCase()
            const group = DEALER_GROUPS.find(item =>
                item.id !== 'others' && item.matches.some(match => type.includes(match))
            )
            return group ? group.id : 'others'
        },
        getMarkerIconClass (spotType) {
            const groupId = this.getDealerGroupId(spotType)
            const group = DEALER_GROUPS.find(item => item.id === groupId)
            return group ? group.icon : 'las la-map-marker'
        }
    }
}
</script>

<style lang="scss" scoped>
  .dealer-map-container {
    height: 100vh;
    position: relative;
  }

  .dealer-map-container > .col {
    position: relative;
  }

  .dealer-map {
      z-index:1;
      width: 100%;
      height: 100%;
    }

  .zoom-controls {
      position: absolute;
      top: calc(8vh + 10px);
      left: 10px;
      z-index: 10;
      display: flex;
      flex-direction: row;
      gap: 2px;
      pointer-events: auto;
    }

  .zoom-btn {
      width: 40px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: pointer;
      font-size: 20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      transition: background-color 0.2s;
    }

  .zoom-btn:hover {
      background-color: #f0f0f0;
    }

  .zoom-btn:active {
      background-color: #e0e0e0;
    }

  .filter-icons {
      position: absolute;
      top: calc(8vh + 60px);
      left: 10px;
      z-index: 10;
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: auto;
    }

  .filter-icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4), 0 0 0 2px rgba(255, 255, 255, 0.8);
      cursor: pointer;
      transition: transform 0.2s;
    }

  .filter-icon:hover {
      transform: scale(1.1);
    }

  .filter-icon:hover .filter-tooltip {
      visibility: visible;
      opacity: 1;
    }

  .filter-icon i {
      font-size: 24px;
      color: #d06f5a;
      transition: opacity 0.2s;
      opacity: 0.3;
    }

  .filter-icon-active i {
      opacity: 1;
    }

  .filter-tooltip {
      position: absolute;
      top: 50%;
      left: 50px;
      transform: translateY(-50%);
      background-color: #000000;
      color: white;
      padding: 6px 10px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.2s, visibility 0.2s;
      pointer-events: none;
      z-index: 10000;
    }

  .filter-tooltip::before {
      content: '';
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border: 5px solid transparent;
      border-right-color: #000000;
    }

  .custom-marker {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 40px;
      height: 40px;
      background-color: white;
      border-radius: 50%;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4), 0 0 0 2px rgba(255, 255, 255, 0.8);
    }

  .custom-marker i {
      font-size: 32px;
      color: #d06f5a;
      z-index: 1;
    }


</style>

<style lang="scss">
  .mapboxgl-popup {
      z-index: 3;
  }

  .brewery-marker {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      position: relative;
  }

  .brewery-marker img {
      width: 50px;
      height: 50px;
      object-fit: contain;
  }

  .brewery-marker img.bar-logo {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
  }
</style>
